import { Breadcrumbs } from "../../CommonElements";
import AbsenStafBulananContain from "../../Component/Absen/containers/AbsenStafBulananContain";
import PageContainer from "../../Layout/Containers/PageContainer";

const AbsenStafBulananPage = () => {
  return (
    <PageContainer
      breadcrumbs={
        <Breadcrumbs
          parent="Sipeg"
          subparent="Absen"
          title="Absen Staf Bulanan"
        />
      }
    >
      <AbsenStafBulananContain />
    </PageContainer>
  );
};

export default AbsenStafBulananPage;
